import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Home } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import { Portfolio } from "./pages/Portfolio";
import { Contact } from "./pages/Contact";
import { SoireesEntreprise } from "./pages/SoireesEntreprise";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public routes with header/footer */}
          <Route path="/" element={
            <>
              <Header />
              <main><Home /></main>
              <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <Header />
              <main><About /></main>
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Header />
              <main><Services /></main>
              <Footer />
            </>
          } />
          <Route path="/portfolio" element={
            <>
              <Header />
              <main><Portfolio /></main>
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Header />
              <main><Contact /></main>
              <Footer />
            </>
          } />
          <Route path="/soirees-entreprise" element={
            <>
              <Header />
              <main><SoireesEntreprise /></main>
              <Footer />
            </>
          } />
          
          {/* Catch all - redirect to home */}
          <Route path="*" element={
            <>
              <Header />
              <main><Home /></main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
